<div class="info-card">
  <div class="info-card__item">
    <span class="info-card__label">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.bankaccountnumber' | translate }}</span>
    @if (bankAccount?.internationalBankAccountNumber) {
      <span class="info-card__value info-card__value--mono">{{ bankAccount?.internationalBankAccountNumber | ibanFormatter }}</span>
    } @else {
      <span class="info-card__value info-card__value--empty">-</span>
    }
  </div>
</div>
